// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/feature-admin/plugin.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/plugins/src/admin/index.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo field-check-app
//     node fleet/fleet.ts check --repo field-check-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * `plugins/admin` — one folder, one plugin, everything it owns.
 *
 * ADMIN ROUTE & NAV CONTRIBUTIONS (feature #8 of Round 2).
 *
 * Admin is a LIBRARY, not a plugin: it holds no persistent state or background
 * loops that must be torn down on account switch. Only its routes and UI
 * contributions are composed here so that a build without admin does not
 * expose `/admin/*`.
 */
import type { Plugin } from "@fleet/kernel";

export interface AdminPluginConfig<TUi = never> {
  contributes?: readonly TUi[];
}

// oxlint-disable-next-line typescript/no-explicit-any
export const adminPlugin: Plugin<AdminPluginConfig<any> | void, any> = {
  id: "admin",
  capabilities: ["window"],

  frontend(ctx) {
    for (const item of ctx.config?.contributes ?? []) {
      ctx.contribute(item);
    }
  },
};
